import React, { useContext } from 'react';
import { AppContext } from './../Contexts/App/AppContext';
import PublicRoutes from './routes';
const Routes = (props) => {
    const appCtx = useContext(AppContext);
    return (
        <PublicRoutes appCtx={appCtx} />
    );
}

export default Routes;